import { useState, useEffect, useMemo, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { retrieveData } from "../../LocalConnection/LocalConnection.js";
import {
  get_all_staff_rights,
  logout_staff,
  server_post_data,
} from "../../ServiceConnection/serviceconnection";
import {
  LayoutDashboard,
  ClipboardList,
  ShoppingCart,
  Package,
  Truck,
  Warehouse,
  ChefHat,
  UtensilsCrossed,
  Users,
  Settings,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  BarChart3,
  FileText,
  UserCheck,
  Tv,
  HelpCircle,
  Receipt,
  Store,
  Weight,
  Blocks,
  LogOut,
  ShoppingBasket,
  Grid3x3,
  SlidersHorizontal,
  PackagePlus,
  List,
  Map,
  Table2,
  Airplay,
  X,
  TrendingUp,
  Coins,
  Percent,
  IndianRupee,
  CupSoda,
  ListOrdered,
  TimerReset,
  KeyRound,
  KeyboardMusic,
  Disc3Icon,
} from "lucide-react";
import { cn } from "../../lib/utils";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "../ui/collapsible";
import { handleError } from "../../CommonJquery/CommonJquery.js";

const navGroups = [
  {
    title: "Main",
    classname: "main",
    defaultOpen: true,
    items: [
      {
        name: "Dashboard",
        href: "/Dashboard",
        icon: LayoutDashboard,
        classname: "dashboard",
      },
      {
        name: "TV Dashboard",
        href: "/tv-dashboard",
        icon: Tv,
        classname: "tv_dashboard",
      },
      {
        name: "Orders & Billing",
        href: "/orders",
        icon: IndianRupee,
        classname: "orders_billing",
      },
      { name: "CRM", href: "/crm", icon: Users, classname: "crm" },
      {
        name: "Reservations",
        href: "/reservations",
        icon: TimerReset,
        classname: "reservations",
      },
    ],
  },
  {
    title: "Reports",
    classname: "reports",
    items: [
      {
        name: "Stock Ledger",
        href: "/stock-ledger",
        icon: FileText,
        classname: "stock_ledger",
      },
      {
        name: "Stock Summary",
        href: "/stock-summary",
        icon: FileText,
        classname: "stock_summary",
      },
      {
        name: "Stock Issue",
        href: "/stock-issue",
        icon: FileText,
        classname: "stock_issue",
      },
      {
        name: "Stock Audit",
        href: "/audit",
        icon: FileText,
        classname: "stock_audit",
      },
      {
        name: "Stock Adjustment",
        href: "/adjustment",
        icon: FileText,
        classname: "stock_adjustment",
      },
      {
        name: "Purchase Order",
        href: "/purchase-order",
        icon: FileText,
        classname: "purchase_order",
      },
      {
        name: "GRN Report",
        href: "/grn-report",
        icon: FileText,
        classname: "grn_report",
      },
      {
        name: "Indent Report",
        href: "/indent",
        icon: FileText,
        classname: "indent_report",
      },
      {
        name: "Consumption Report",
        href: "/consumption",
        icon: TrendingUp,
        classname: "consumption_report",
      },
      {
        name: "Recipe Costing",
        href: "/recipe-costing",
        icon: BarChart3,
        classname: "recipe_costing",
      },

      // === Existing Reports ===
      {
        name: "Master Report",
        href: "/master-report",
        icon: FileText,
        classname: "master_report",
      },
      {
        name: "Dayend Reports",
        href: "/day-end-reports",
        icon: FileText,
        classname: "dayend_reports",
      },
      {
        name: "Sales Reports",
        href: "/sales-reports",
        icon: TrendingUp,
        classname: "sales_reports",
      },
      {
        name: "Kot Reports",
        href: "/kot-sales-reports",
        icon: BarChart3,
        classname: "kot_reports",
      },
      {
        name: "Customer Wise Reports",
        href: "/customer-wise-reports",
        icon: CupSoda,
        classname: "customer_wise_reports",
      },
      {
        name: "Order Modification Reports",
        href: "/order-modification-reports",
        icon: ListOrdered,
        classname: "order_modification_reports",
      },
      {
        name: "KOT Modification Reports",
        href: "/kot-modification-reports",
        icon: KeyboardMusic,
        classname: "kot_modification_reports",
      },
      {
        name: "Complimentary Reports",
        href: "/complimentary-reports",
        icon: Disc3Icon,
        classname: "complimentary_reports",
      },
      {
        name: "Items Sales Reports",
        href: "/items-sales-reports",
        icon: Package,
        classname: "items_reports",
      },
      {
        name: "Payment Summary Reports",
        href: "/payment-summary-reports",
        icon: Package,
        classname: "payment_summary_reports",
      },
      {
        name: "Tip Reports",
        href: "/tip-reports",
        icon: Coins,
        classname: "tip_reports",
      },
      {
        name: "Discount Reports",
        href: "/discount-reports",
        icon: Percent,
        classname: "discount_reports",
      },
    ],
  },

  {
    title: "Purchase & Inventory",
    classname: "purchase_inventory",
    defaultOpen: false,
    items: [
      {
        name: "Units Master",
        href: "/view-units",
        icon: Weight,
        badge: null,
        classname: "units_master",
      },
      {
        name: "Departments",
        href: "/departments",
        icon: Blocks,
        badge: null,
        classname: "departments",
      },
      {
        name: "Items Master",
        href: "/ingredient-view",
        icon: ShoppingBasket,
        badge: null,
        classname: "ingredient_master",
      },
      {
        name: "Vendor Master",
        href: "/vendor-master",
        icon: Store,
        badge: null,
        classname: "vendor_master",
      },
      {
        name: "Purchase Orders",
        href: "/purchase-orders",
        icon: ShoppingCart,
        classname: "purchase_orders",
      },
      {
        name: "Material Receiving",
        href: "/grn",
        icon: Truck,
        classname: "grn_receiving",
      },
      {
        name: "Issue Material",
        href: "/store-managment",
        icon: Airplay,
        classname: "store_management",
      },
      {
        name: "Indents",
        href: "/indents",
        icon: ClipboardList,
        classname: "indents",
      },
      {
        name: "PO Approval",
        href: "/approval-po",
        icon: UserCheck,
        classname: "po_approval",
      },
      {
        name: "Stock & Inventory",
        href: "/inventory",
        icon: Warehouse,
        classname: "inventory_management",
      },
      {
        name: "Audit Inventory",
        href: "/audits",
        icon: Warehouse,
        classname: "audit_inventory",
      },
      {
        name: "Adjustment",
        href: "/adjustments",
        icon: Warehouse,
        classname: "adjustment_management",
      },
      {
        name: "Recipes",
        href: "/recipe-view",
        icon: ChefHat,
        classname: "recipe",
      },
    ],
  },
  {
    title: "Restaurant Management",
    classname: "restaurant_management",
    items: [
      {
        name: "Table Management",
        href: "/table-management",
        icon: Table2,
        classname: "table_management",
      },
      {
        name: "Area Management",
        href: "/area-management",
        icon: Map,
        classname: "area_management",
      },
    ],
  },
  {
    title: "Menu Management",
    classname: "menu_management",
    items: [
      {
        name: "Menu Category",
        href: "/menu-category",
        icon: Grid3x3,
        classname: "menu_category",
      },
      {
        name: "Item Variation",
        href: "/item-variation",
        icon: SlidersHorizontal,
        classname: "item_variation",
      },
      {
        name: "Item Addons",
        href: "/item-addons",
        icon: PackagePlus,
        classname: "item_addons",
      },
      { name: "Items", href: "/items", icon: List, classname: "items" },
    ],
  },
  {
    title: "Staff Management",
    classname: "staff_management",
    items: [
      {
        name: "Staff",
        href: "/staff-management",
        icon: Users,
        classname: "staff",
      },
      {
        name: "Roles & Permissions",
        href: "/roles",
        icon: Settings,
        classname: "roles_permissions",
      },
    ],
  },
];

const bottomNav = [
  {
    name: "Outlet Settings",
    href: "/outlet-settings",
    icon: Settings,
    classname: "outlet_settings",
  },
  { name: "Help & Support", href: "/help", icon: HelpCircle },
];

export function Sidebar() {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);
  const [page_chekt, setPage_chekt] = useState([]);
  const [rightpage, setrightpage] = useState([]);
  const [designationpage, setDesignationPage] = useState([]);
  const access_permission = retrieveData("access_permission");
  const adminName = retrieveData("admin_name");
  const adminRole = retrieveData("designation_name");
  const restroName = retrieveData("restaurant_name");
  const activeItemRef = useRef(null);

  // ✅ Check if user is Owner
  const isOwner = adminRole === "Owner";

  // ✅ Parse access permissions into a Set for fast lookup (skip if Owner)
  const userAccessPages = useMemo(() => {
    if (isOwner) return new Set();

    if (!access_permission) return new Set();

    const pages = access_permission.split("/").map((item) => {
      if (item.includes("@")) {
        return item.split("@")[0];
      }
      return item;
    });

    return new Set(pages);
  }, [access_permission, isOwner]);

  // ✅ Helper function to check if user has access to a page
  const hasAccess = (href) => {
    if (isOwner) return true;

    if (!href) return false;

    const pageUrl = href.startsWith("/") ? href.substring(1) : href;

    return userAccessPages.has(pageUrl);
  };

  // ✅ Filter navigation groups based on user access (or show all if Owner)
  const filteredNavGroups = useMemo(() => {
    if (isOwner) return navGroups;

    return navGroups
      .map((group) => {
        const filteredItems = group.items.filter((item) =>
          hasAccess(item.href),
        );

        if (filteredItems.length > 0) {
          return {
            ...group,
            items: filteredItems,
          };
        }
        return null;
      })
      .filter((group) => group !== null);
  }, [userAccessPages, isOwner]);

  // ✅ Filter bottom navigation based on user access (or show all if Owner)
  const filteredBottomNav = useMemo(() => {
    if (isOwner) return bottomNav;

    return bottomNav.filter((item) => hasAccess(item.href));
  }, [userAccessPages, isOwner]);

  useEffect(() => {
    if (!isOwner) {
      master_data_get_staff_right();
    }
  }, [isOwner]);

  // ✅ Returns active group + all defaultOpen groups (deduplicated)
  const getActiveGroups = (groups) => {
    const navToUse = groups || filteredNavGroups;

    const activeGroup = navToUse.find((group) =>
      group.items.some((item) => item.href === location.pathname),
    );

    const defaultOpenTitles = navToUse
      .filter((g) => g.defaultOpen)
      .map((g) => g.title);

    if (activeGroup) {
      return [...new Set([activeGroup.title, ...defaultOpenTitles])];
    }

    return defaultOpenTitles;
  };

  useEffect(() => {
    if (activeItemRef.current) {
      const timer = setTimeout(() => {
        activeItemRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }, 150);
      return () => clearTimeout(timer);
    }
  }, [location.pathname]);

  // Initialize open groups based on active route
  const [openGroups, setOpenGroups] = useState(() =>
    getActiveGroups(navGroups),
  );

  // ✅ Update open groups on route change OR when filteredNavGroups updates
  useEffect(() => {
    setOpenGroups(getActiveGroups());
  }, [location.pathname, filteredNavGroups]);

  const toggleGroup = (title) => {
    setOpenGroups((prev) =>
      prev.includes(title) ? prev.filter((t) => t !== title) : [...prev, title],
    );
  };

  const handleLogout = async () => {
    await server_post_data(logout_staff, null)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setShowLogoutDialog(false);
          navigate("/");
        }
      })
      .catch((error) => {
        handleError(error);
      });
  };

  /******************* Staff Right Activity Start ****************/
  // FIX: added location.pathname to deps so hide/show re-evaluates on every navigation,
  // not just when page_chekt is (re)loaded.
  useEffect(() => {
    if (isOwner) return;

    var currentPage = window.location.pathname.split("/").pop();
    var rrr = Triosidebarhideshow(currentPage);
    if (rrr) {
      goback();
    }

    if (page_chekt[currentPage] && page_chekt[currentPage]["insidepage"]) {
      page_chekt[currentPage]["insidepage"].split("/").forEach(function (item) {
        const insidePages_vw = item.split("@");
        if (
          designationpage[currentPage] &&
          Object.values(designationpage[currentPage]).includes(
            insidePages_vw[0],
          )
        ) {
          // item is present in the designation so no need to remove
        } else {
          var elementsToRemove = document.querySelectorAll(
            "." + insidePages_vw[0],
          );
          elementsToRemove.forEach(function (element) {
            element.remove();
          });
        }
      });
    }

    Object.keys(page_chekt).forEach(function (key) {
      var itempi = page_chekt[key].page_url_id;
      if (!designationpage[itempi]) {
        document
          .querySelectorAll(`button.${itempi}`)
          .forEach(function (element) {
            element.remove();
          });
        document
          .querySelectorAll(`[href="/${itempi}"]`)
          .forEach(function (element) {
            element.remove();
          });
      }
    });
  }, [page_chekt, isOwner, location.pathname]);
  /******************* Staff Right Activity End ****************/

  const master_data_get_staff_right = async () => {
    const fd = new FormData();
    fd.append("flag", "10");
    await server_post_data(get_all_staff_rights, fd)
      .then((Response) => {
        // FIX: check error BEFORE touching Response.data.message.data.
        // Previously this ran unconditionally and crashed whenever the API
        // returned an error (message is a string in that case, not {data: []}).
        if (Response.data.error) {
          // handleError(Response.data.message);
          return;
        }

        Response.data.message.data.forEach(function (item) {
          var idd = item.page_url_id;
          setPage_chekt((prevState) => ({
            ...prevState,
            [idd]: {
              page_url_id: item.page_url_id,
              insidepage: item.insidepage,
            },
          }));
        });

        // FIX: guard against access_permission being null/undefined
        const datam = (access_permission || "").split("/");
        const newDataxt = datam.reduce((acc, item) => {
          if (item.includes("@")) {
            const [page, ...extras] = item.split("@");
            if (!acc[page]) {
              acc[page] = {};
            }
            extras.forEach((extra, idx) => {
              acc[page][idx] = extra;
            });
          } else {
            acc[item] = { ["class_list"]: "" };
          }
          return acc;
        }, {});
        setDesignationPage(newDataxt);
        setrightpage(Response.data.message.data);
      })
      .catch((error) => {});
  };

  function Triosidebarhideshow(pagelink) {
    if (isOwner) return "";

    if (designationpage[pagelink]) {
      return "";
    } else {
      if (!page_chekt[pagelink]) {
        return "";
      } else {
        return "dsplynoe";
      }
    }
  }

  function goback() {
    window.history.back();
  }

  const getInitials = (name = "") => {
    if (!name) return "";

    return name
      .trim()
      .split(/\s+/)
      .map((word) => word[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <>
      <aside
        className={cn(
          "fixed left-0 top-0 z-40 h-screen bg-sidebar border-r border-sidebar-border transition-all duration-300 flex flex-col",
          collapsed ? "w-20" : "w-64",
        )}
      >
        {/* Logo */}
        <div className="flex h-16 items-center justify-between px-4 border-b border-sidebar-border">
          {!collapsed && (
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-sidebar-primary flex items-center justify-center">
                <UtensilsCrossed className="w-5 h-5 text-sidebar-background" />
              </div>
              <div>
                <h1 className="font-bold text-sidebar-foreground text-lg tracking-tight">
                  {restroName}
                </h1>
                <p className="text-xs text-sidebar-foreground/70">Restaurant</p>
              </div>
            </div>
          )}
          {collapsed && (
            <div className="w-10 h-10 rounded-xl bg-sidebar-primary flex items-center justify-center mx-auto">
              <UtensilsCrossed className="w-5 h-5 text-sidebar-background" />
            </div>
          )}
        </div>

        {/* Main Navigation */}
        <nav className="flex-1 px-3 py-4 space-y-2 overflow-y-auto">
          {filteredNavGroups.map((group) => (
            <div key={group.title}>
              {!collapsed ? (
                <Collapsible
                  open={openGroups.includes(group.title)}
                  onOpenChange={() => toggleGroup(group.title)}
                >
                  <CollapsibleTrigger
                    className={` ${group.classname} flex items-center justify-between w-full px-3 py-2 text-xs font-semibold text-sidebar-foreground/60 uppercase tracking-wider hover:text-sidebar-foreground transition-colors`}
                  >
                    <span>{group.title}</span>
                    <ChevronDown
                      className={cn(
                        "w-4 h-4 transition-transform",
                        openGroups.includes(group.title) && "rotate-180",
                      )}
                    />
                  </CollapsibleTrigger>
                  <CollapsibleContent className="space-y-1 mt-1">
                    {group.items.map((item) => {
                      const isActive = location.pathname === item.href;
                      return (
                        <Link
                          key={item.name}
                          to={item.href}
                          ref={isActive ? activeItemRef : null}
                          className={cn(
                            "flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 group relative",
                            item.classname,
                            isActive
                              ? "bg-sidebar-primary text-sidebar-background"
                              : "text-sidebar-foreground hover:bg-sidebar-accent hover:text-sidebar-foreground",
                          )}
                        >
                          <item.icon className="w-5 h-5 flex-shrink-0" />
                          <span className="flex-1">{item.name}</span>
                          {item.badge && (
                            <Badge
                              variant="secondary"
                              className={cn(
                                "h-5 px-1.5 text-xs border-0",
                                isActive
                                  ? "bg-sidebar-background/20 text-sidebar-background"
                                  : "bg-sidebar-primary/20 text-sidebar-primary",
                              )}
                            >
                              {item.badge}
                            </Badge>
                          )}
                        </Link>
                      );
                    })}
                  </CollapsibleContent>
                </Collapsible>
              ) : (
                <div className="space-y-1">
                  {group.items.map((item) => {
                    const isActive = location.pathname === item.href;
                    return (
                      <Link
                        key={item.name}
                        to={item.href}
                        title={item.name}
                        className={cn(
                          "flex items-center justify-center p-2.5 rounded-lg transition-all duration-200",
                          item.classname,
                          isActive
                            ? "bg-sidebar-primary text-sidebar-background"
                            : "text-sidebar-foreground hover:bg-sidebar-accent",
                        )}
                      >
                        <item.icon className="w-5 h-5" />
                      </Link>
                    );
                  })}
                </div>
              )}
            </div>
          ))}
        </nav>

        {/* Divider */}
        <div className="px-4">
          <div className="border-t border-sidebar-border" />
        </div>

        {/* Bottom Navigation */}
        <div className="px-3 py-4 space-y-1">
          {filteredBottomNav.map((item) => {
            const isActive = location.pathname === item.href;
            return (
              <Link
                key={item.name}
                to={item.href}
                className={cn(
                  "flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200",
                  item.classname,
                  isActive
                    ? "bg-sidebar-primary text-sidebar-background"
                    : "text-sidebar-foreground hover:bg-sidebar-accent",
                  collapsed && "justify-center",
                )}
              >
                <item.icon className="w-5 h-5 flex-shrink-0" />
                {!collapsed && <span>{item.name}</span>}
              </Link>
            );
          })}
          <button
            onClick={() => setShowLogoutDialog(true)}
            className={cn(
              "flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 text-sidebar-foreground hover:bg-sidebar-accent w-full",
              collapsed && "justify-center",
            )}
          >
            <LogOut className="w-5 h-5 flex-shrink-0" />
            {!collapsed && <span>Logout</span>}
          </button>
        </div>

        {/* User Profile */}
        <div className="px-3 py-4 border-t border-sidebar-border">
          <div
            className={cn(
              "flex items-center gap-3",
              collapsed && "justify-center",
            )}
          >
            <div className="w-10 h-10 rounded-full bg-sidebar-primary flex items-center justify-center text-sidebar-background font-semibold">
              {getInitials(adminName)}
            </div>
            {!collapsed && (
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-sidebar-foreground truncate">
                  {adminName}
                </p>
                <p className="text-xs text-sidebar-foreground/70">
                  {adminRole}
                </p>
              </div>
            )}
          </div>
        </div>
      </aside>

      {/* Logout Confirmation Modal */}
      {showLogoutDialog && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-black/50 z-50 animate-in fade-in duration-200"
            onClick={() => setShowLogoutDialog(false)}
          />

          {/* Modal */}
          <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-full max-w-md animate-in fade-in zoom-in-95 duration-200">
            <div className="bg-card border border-border rounded-lg shadow-lg p-6">
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h2 className="text-lg font-semibold text-foreground">
                    Confirm Logout
                  </h2>
                  <p className="text-sm text-muted-foreground mt-1">
                    Are you sure you want to logout?
                  </p>
                </div>
                <button
                  onClick={() => setShowLogoutDialog(false)}
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>

              <div className="flex justify-end gap-3 mt-6">
                <Button
                  variant="outline"
                  onClick={() => setShowLogoutDialog(false)}
                  className="px-4"
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleLogout}
                  className="px-4 bg-primary hover:bg-primary/90 text-white"
                >
                  Confirm
                </Button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
